import { render, staticRenderFns } from "./courseMain.vue?vue&type=template&id=02d07dba&scoped=true&"
import script from "./courseMain.vue?vue&type=script&lang=js&"
export * from "./courseMain.vue?vue&type=script&lang=js&"
import style0 from "./courseMain.vue?vue&type=style&index=0&id=02d07dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d07dba",
  null
  
)

export default component.exports